import { Avis } from './avis';
import { Diffuseur } from './diffuseur';

export class AvisDiffuseurId {
    public avisId: number;
    public diffuseurId: number;
    public supportDiffusion: string;

    constructor() {
    }
}
